import SignIn from './SignIn'
import './SignIn.css'

export default SignIn



// WEBPACK FOOTER //
// ./src/features/Personal/containers/SignIn/index.js